import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaixaGerenciarDetalharComponent } from './caixa-gerenciar-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: CaixaGerenciarDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class CaixaGerenciarDetalharRoutingModule { }
